
import VueRouter from 'vue-router'
import Home from './main/index'
import Index from './components/playerlist'
import UserMain from './usercenter/usermain'
import Comment from './usercenter/comment'
import DataCenter from './usercenter/datacenter'
import Fans from './usercenter/fans'
import Message from './usercenter/message'
import Login from './components/login'
import Reg from './components/reg'
import RegSucc from './components/regsuccess'
import FileUpload from './usercenter/fileupload'
import PlayerDetail from './components/playerdetail'
import UserDetail from './components/userdetail'
import UserActivity from './components/useractivity'
import Video from './components/video'
import Article from './components/article'
import JoinSucc from './usercenter/joinsuccess'
import LogOut from './components/logout'
import Fpass from './components/findpassword'
import Pset from './components/passwordset'
import Psetsucc from './components/passwordset_success'
import PlayerList from './usercenter/player_list'
import PlayerEdit from './usercenter/player_edit'
import ArticlePublish from './usercenter/article_publish'
import ArticleList from './usercenter/article_list'
// import ArticleListView from './components/article_list'
import ArticleListMenu from './components/article_list_menu'
import ArticleEdit from './usercenter/article_edit'
import UserInfo from './usercenter/userinfo'
import Vue from 'vue'
import Service from './components/service'
import Privacy from './components/privacy'
import InterViewQPulish from './usercenter/interview_question_publish'
import TalkJob from './components/talk_job'

Vue.use(VueRouter)

/*在router里面直接配置启动的首页 */

const router =new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'index',
            component: Home
        },
        {
            path: '/aaa',
            name: 'index',
            component: Index
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/reg',
            name: 'reg',
            component: Reg
        },
        {
            path: '/regsucc',
            name: 'regsucc',
            component: RegSucc
        },
        {
            path: '/playerdetail',
            name: 'playerdetail',
            component: PlayerDetail
        },
        {
            path: '/userdetail',
            name: 'userdetail',
            component: UserDetail
        },
        {
            path: '/useractivity',
            name: 'useractivity',
            component: UserActivity
        },
        {
            path: '/video',
            name: 'video',
            component: Video
        },
        {
            path: '/article-:id(\\d+).html',
            name: 'article',
            component: Article
        },      
        {
            path: '/logout',
            name: 'logout',
            component: LogOut
        },   
        {
            path: '/findpassword',
            name: 'fpass',
            component: Fpass
        },      
        {
            path: '/passwordset',
            name: 'pset',
            component: Pset
        },   
        {
            path: '/passwordsetsucc',
            name: 'psetsucc',
            component: Psetsucc
        },  
        // {
        //     path: '/article/list-:id(\\d+).html',
        //     name: 'articlelistview',
        //     component: ArticleListView
        // }, 
        {
            path: '/article/list-:id(\\d+).html',
            name: 'articlelistview',
            component: ArticleListMenu
        }, 
        {
            path: '/service',
            name: 'service',
            component: Service
        },  
        {
            path: '/privacy',
            name: 'privacy',
            component: Privacy
        },
        {
            path: '/talkjob',
            name: 'talkjob',
            component: TalkJob
        },                                 
        {
            path: '/user/center',
            name: 'user',
            component: UserMain,
            //redirect:'/user/comment',
            children:[
                {
                    path: '/user/comment',
                    name: 'comment',
                    component: Comment
                },
                {
                    path: '/user/fans',
                    name: 'fans',
                    component: Fans
                },
                {
                    path: '/user/datacenter',
                    name: 'datacenter',
                    component: DataCenter
                },
                {
                    path: '/user/fileupload',
                    name: 'fileupload',
                    component: FileUpload
                },
                {
                    path: '/user/Message',
                    name: 'message',
                    component: Message
                },
                {
                    path: '/user/joinsucc',
                    name: 'joinsucc',
                    component: JoinSucc
                },
                {
                    path: '/user/playerlist',
                    name: 'playerlist',
                    component: PlayerList
                },
                {
                    path: '/user/playeredit',
                    name: 'playeredit',
                    component: PlayerEdit
                }
                ,
                {
                    path:'/user/articlepublish',
                    name: 'articlepublish',
                    component: ArticlePublish
                },
                {
                    path:'/user/articlelist',
                    name: 'articlelist',
                    component: ArticleList
                },
                {
                    path:'/user/articleedit',
                    name: 'articleedit',
                    component: ArticleEdit
                },
                {
                    path:'/user/info',
                    name: 'userinfo',
                    component: UserInfo
                },
                {
                    path:'/user/interviewqpublish',
                    name:'interviewqp',
                    component:InterViewQPulish
                }
            ]
        },
    ]
})


// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
    //不需要验证登录的Url
    var notNeedUnAuthUrls=['/login','/','/reg','/regsucc','/logout','/userdetail','/video','/findpassword','/passwordset','/passwordsetsucc','/article/list','/article','/service','/privacy'];
    var canGoNext=false;
    for(var i=0;i<notNeedUnAuthUrls.length;i++){
        if(to.path.indexOf(notNeedUnAuthUrls[i])>-1){
            canGoNext=true;
        }
    }
    if (canGoNext) {
      next();
    } else {
      let token = localStorage.getItem('Authorization');
   
      if (token === null || token === '') {
        next('/login');
      } else {
        next();
      }
    }
    //next();
  });

export default router